import { makeObservable, observable, action } from "mobx";

class addEventStore {
  modalVisible = false;

  constructor() {
    makeObservable(this, {
      modalVisible: observable,
      setModalVisible: action,
    });
  }

  getModalIsVisible() {
    return this.modalVisible;
  }

  setModalVisible(value: boolean) {
    this.modalVisible = value;
  }
}

export default new addEventStore();
